import React from "react";
import Functions, {Particles} from './functions';
import moment from 'moment';

export default class Clock extends Functions {

	constructor(props) {
		super(props);
	}

	async process(data, image, timeframe, controller) {

	}

	async paint(ctx, timeframe, settings, color) {
		let date = moment().format("dddd MMMM Do YYYY h:mm A");
		ctx.font = "italic bold 1vw Arial ";
		ctx.textAlign = "center";
		ctx.textBaseline = "middle";
		ctx.fillStyle = color;
		let text = ctx.measureText(date);
		let scalex = settings[0][2]*ctx.canvas.width / (text.width+10);
		let scaley = settings[0][3]*ctx.canvas.width / (text.actualBoundingBoxAscent + text.actualBoundingBoxDescent+10);
		ctx.save();
		ctx.scale(scalex, scaley);
		ctx.fillText(date, (settings[0][0]*ctx.canvas.width+settings[0][2]/2*ctx.canvas.width)/scalex, (settings[0][1]*ctx.canvas.height+settings[0][3]/2*ctx.canvas.height)/scaley+2);
		ctx.restore();
	}

}